import { render, staticRenderFns } from "./KnowledgeWrapper.vue?vue&type=template&id=c06e0576&"
import script from "./KnowledgeWrapper.vue?vue&type=script&lang=js&"
export * from "./KnowledgeWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports